export const createClient = (ApiClientConstructor) => {
    let instance;
    return {
        init: (baseUrl) => {
            instance = new ApiClientConstructor({ baseUrl });
        },
        getInstance: () => {
            if (!instance) {
                throw new Error('API client is not initialized');
            }
            return instance;
        },
    };
};
export const createClientWithCustomFetch = (ApiClientConstructor) => {
    let instance;
    return {
        init: (baseUrl, fetchWithHeaders) => {
            instance = new ApiClientConstructor({ baseUrl, customFetch: fetchWithHeaders });
        },
        getInstance: () => {
            if (!instance) {
                throw new Error('API client is not initialized');
            }
            return instance;
        },
    };
};
//# sourceMappingURL=factory.js.map